import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import "./forumsTable.scss";
import ScrollToTopOnMount from "../../../../ScrollToTop";
import { parseDate } from "../parseDate";
import Loading from "../../../Loading";
import PageTitle from "components/common/Layout/PageTitle";
import BackButton from "components/common/BackButton";
import { FORUM } from "endpointsConst";


function ForumsTable() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();
    const navigate = useNavigate();

    const currentPage = t("forums.heading");

    const handleClick = (item) => {
        navigate(`/forums/topic/${item.id}`);
    };

    const loadForums = () => {
        setLoading(true);
        axios
            .get(FORUM + "/categories")
            .then((res) => {
                setItems(res.data.items);
            })
            .catch((e) => {
                console.log(e.response);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        loadForums();
    }, []);

    return (
        <>
            <ScrollToTopOnMount />
            <BackButton />
            <PageTitle>{currentPage}</PageTitle>

            <table className={"data-table forums"} cellSpacing="0">
                <thead className="data-table__table-header">
                    <tr>
                        <th className="data-table__head" align="left">
                            {t("forums.table.forums")}
                        </th>
                        <th className="data-table__head" align="center">
                            {t("forums.table.topics")}
                        </th>
                        <th className="data-table__head" align="center">
                            {t("forums.table.message")}
                        </th>
                        <th className="data-table__head" align="center">
                            {t("forums.table.last_message")}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {loading && (
                        <tr>
                            <td colSpan={4}>
                                <Loading />
                            </td>
                        </tr>
                    )}
                    {items.map((el, index) => (
                        <React.Fragment key={el.id}>
                            <tr className="data-table__table-row data-table__table-column" onClick={() => handleClick(el)}>
                                <td className="data-table__cell">
                                  <span className="forums__headings">{t("forums.table.forums")}</span>
                                    <p className="forums__title">{el.category_title}</p>
                                </td>
                                <td className="data-table__cell" align="center">
                                  <span className="forums__headings">{t("forums.table.topics")}</span>
                                    <p className="forums__count">{el.forum_tickets_count}</p>
                                </td>
                                <td className="data-table__cell" align="center">
                                  <span className="forums__headings">{t("forums.table.message")}</span>
                                    <p className="forums__count">
                                        {el.forum_messages_count || "0"}
                                    </p>
                                </td>
                                <td className="data-table__cell" align="center">
                                  <span className="forums__headings">{t("forums.table.last_message")}</span>
                                    <p className="forums__time">
                                        {el.last_created_at ? parseDate(el.last_created_at) : "-"}
                                    </p>
                                </td>
                            </tr>
                        </React.Fragment>
                    ))}
                </tbody>
            </table>
        </>
    );
}

export default ForumsTable;
